import React, { useEffect, useState, useCallback } from "react";
import { db, storage } from "../../pagini/Firebase";
import { collection, query, orderBy, limit, getDocs, addDoc, where, doc, setDoc, getDoc} from "firebase/firestore";
import { getAuth } from "firebase/auth"; // Importă getAuth pentru autentificare
import { Timestamp } from "firebase/firestore";
import { ref as storageRef, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import UserDetailsModal from "../../UserDetailsModal";
import { deleteDoc } from "firebase/firestore";

import "../stiluri/PrivireGenerala.css"; // Importă fișierul CSS
// Modal pentru afișarea detaliilor utilizatorului




const PrivireGenerala = ({ beneficiar }) => {
  const [ultimaActiune, setUltimaActiune] = useState(null);
  const [comentarii, setComentarii] = useState([]); // State pentru comentarii
  const [comentariu, setComentariu] = useState(""); // State pentru textul comentariului
  const [loadingComentarii, setLoadingComentarii] = useState(true);
  const [modalUserDetails, setModalUserDetails] = useState(null); // State pentru modalul de detalii utilizator
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
const esteDecedat = beneficiar?.datadeces && new Date(beneficiar.datadeces) < new Date();
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [localBeneficiar, setLocalBeneficiar] = useState(beneficiar);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [editingComentariuId, setEditingComentariuId] = useState(null);
const [editingComentariuText, setEditingComentariuText] = useState("");
const [showOldCommentIds, setShowOldCommentIds] = useState([]);
const [showDropdownId, setShowDropdownId] = useState(null);




const calculeazaVarsta = (dataNasteriiStr, dataReferintaStr = null) => {
  if (!dataNasteriiStr) return null;

  const dataNasterii = new Date(dataNasteriiStr);
  const referinta = dataReferintaStr ? new Date(dataReferintaStr) : new Date();

  let varsta = referinta.getFullYear() - dataNasterii.getFullYear();
  const lunaDiferenta = referinta.getMonth() - dataNasterii.getMonth();

  if (
    lunaDiferenta < 0 ||
    (lunaDiferenta === 0 && referinta.getDate() < dataNasterii.getDate())
  ) {
    varsta--;
  }

  return varsta;
};

const toggleOldComment = (id) => {
  setShowOldCommentIds((prev) =>
    prev.includes(id) ? prev.filter((cid) => cid !== id) : [...prev, id]
  );
};
// Stergere comentarii
const handleDeleteComentariu = async (id) => {
  if (!window.confirm("Sigur vrei să ștergi comentariul?")) return;
  try {
    const docRef = doc(db, "ComentariiBeneficiari", beneficiar.cnp, "comentarii", id);
    await deleteDoc(docRef);
    fetchComentarii();
  } catch (err) {
    console.error("Eroare la ștergere comentariu:", err);
  }
};
// Functie edit comentarii
const startEditComentariu = (comentariu) => {
  const auth = getAuth();
  const user = auth.currentUser;

  // Verifică dacă utilizatorul este cel care a postat
  if (user.email !== comentariu.userEmail) return;

  // Verifică limita de 24h
  const acum = new Date();
  const timestampComentariu = comentariu.timestamp?.toDate ? comentariu.timestamp.toDate() : new Date(comentariu.timestamp);
  const diffOre = (acum - timestampComentariu) / (1000 * 60 * 60);

  if (diffOre > 24) {
    alert("Poți modifica comentariul doar în primele 24 de ore.");
    return;
  }

  setEditingComentariuId(comentariu.id);
  setEditingComentariuText(comentariu.comentariu);
};

// Functie salvare edit comentariu
const saveEditComentariu = async () => {
  if (!editingComentariuText.trim() || !editingComentariuId) return;

  try {
    const docRef = doc(db, "ComentariiBeneficiari", beneficiar.cnp, "comentarii", editingComentariuId);

    // Salvăm versiunea veche
    const comentariuDoc = await getDoc(docRef);
    const vechiComentariu = comentariuDoc.exists() ? comentariuDoc.data().comentariu : "";

    await setDoc(docRef, {
      previousComentariu: vechiComentariu, // versiunea veche
      comentariu: editingComentariuText,
      editedAt: Timestamp.now() // momentul editării
    }, { merge: true });

    setEditingComentariuId(null);
    setEditingComentariuText("");
    fetchComentarii();
  } catch (error) {
    console.error("Eroare la salvarea comentariului editat:", error);
  }
};


  // Funcție pentru deschiderea imaginii într-o fereastră nouă
  const openImageInNewWindow = (imageUrl) => {
    window.open(imageUrl, "_blank", "width=800,height=600"); // Deschide fereastra cu imaginea
    
  };

useEffect(() => {
  const fetchUltimaActiune = async () => {
    if (!beneficiar || !beneficiar.cnp) return;

    console.log("CNP folosit la fetch ultima actiune:", beneficiar.cnp);

    const colRef = collection(db, "ActiuniBeneficiari", beneficiar.cnp, "actiuni");
    const q = query(colRef, orderBy("data_ora", "desc"), limit(1));
    const snapshot = await getDocs(q);

    console.log("ActiuniBeneficiari query docs:", snapshot.docs.map(doc => doc.data()));

    if (!snapshot.empty) {
      const actiuneData = snapshot.docs[0].data();
      setUltimaActiune(actiuneData);
    } else {
      setUltimaActiune(null);
    }
  };

  fetchUltimaActiune();
}, [beneficiar]);


useEffect(() => {
  const fetchUltimaFotografieProfil = async () => {
    if (!beneficiar || !beneficiar.cnp) return;

    try {
      const fotoProfilRef = collection(db, "Beneficiari", beneficiar.cnp, "fotografie_profil");
      const q = query(fotoProfilRef, orderBy("uploadedAt", "desc"), limit(1));
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const ultimaFoto = snapshot.docs[0].data();
        setLocalBeneficiar((prev) => ({
          ...prev,
          fotografie: ultimaFoto.url || prev.fotografie
        }));
      }
    } catch (error) {
      console.error("Eroare la fetch fotografia profil:", error);
    }
  };

  fetchUltimaFotografieProfil();
}, [beneficiar]);

   // Upload fotografie
  const handlePhotoChange = (event) => {
  const file = event.target.files[0];
  if (!file || !localBeneficiar?.cnp) return;

  setUploadingPhoto(true);
  setUploadProgress(0);

  const path = `${localBeneficiar.cnp}/fotografie_profil/${file.name}`;
  const storageReference = storageRef(storage, path);
  const uploadTask = uploadBytesResumable(storageReference, file);

  uploadTask.on(
    "state_changed",
    (snapshot) => {
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      setUploadProgress(Math.round(progress));
    },
    (error) => {
      console.error("Eroare la upload fotografie:", error);
      setUploadingPhoto(false);
      alert("Eroare la încărcarea fotografiei!");
    },
    async () => {
      try {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);

        // Actualizează câmpul `fotografie` cu ultima poză încărcată
        const docRef = doc(db, "Beneficiari", localBeneficiar.cnp);
        await setDoc(docRef, { fotografie: downloadURL }, { merge: true });

        // Salvează metadatele în subcolecția `fotografie_profil`
        const fotoRef = collection(db, "Beneficiari", localBeneficiar.cnp, "fotografie_profil");
        await addDoc(fotoRef, {
          fileName: file.name,
          fileSize: file.size,
          contentType: file.type,
          url: downloadURL,
          uploadedAt: Timestamp.now(),
          uploadedBy: getAuth().currentUser?.email || "necunoscut"
        });

        // Actualizează localBeneficiar pentru UI
        const updatedSnap = await getDocs(query(collection(db, "Beneficiari"), where("cnp", "==", localBeneficiar.cnp)));
        if (!updatedSnap.empty) {
          setLocalBeneficiar(updatedSnap.docs[0].data());
        }
        setUploadingPhoto(false);
        setUploadProgress(0);
        alert("Fotografia a fost încărcată și salvată cu succes!");
      } catch (err) {
        console.error("Eroare la salvarea în Firestore:", err);
        alert("Eroare la salvarea metadatelor în Firestore!");
        setUploadingPhoto(false);
      }
    }
  );
};
  // Deschide dialogul de fișier când dai click pe buton
  const openFileDialog = () => {
    document.getElementById("fileInput").click();
  };




 // Fetch-ul pentru comentarii
const fetchComentarii = useCallback(async () => {
  if (!beneficiar || !beneficiar.cnp) return;

  const colRef = collection(db, "ComentariiBeneficiari", beneficiar.cnp, "comentarii");
  const q = query(colRef, orderBy("timestamp", "desc")); // fără limit(1)
  const snapshot = await getDocs(q);

  if (!snapshot.empty) {
    const comentariiData = await Promise.all(
      snapshot.docs.map(async (doc) => {
        const data = doc.data();
        const userEmail = data.userEmail;

        let userFullName = userEmail;
        if (userEmail) {
          const userSnapshot = await getDocs(
            query(collection(db, "Utilizatori"), where("email", "==", userEmail))
          );
          if (!userSnapshot.empty) {
            const userData = userSnapshot.docs[0].data();
            userFullName = `${userData.nume} ${userData.prenume}`;
          }
        }

        return {
          ...data,
          id: doc.id,
          userFullName,
        };
      })
    );

    setComentarii(comentariiData);
  } else {
    setComentarii([]);
  }

  setLoadingComentarii(false);
}, [beneficiar]);


  useEffect(() => {
    fetchComentarii();
  }, [beneficiar, fetchComentarii]);
  
  

  // Handler pentru comentarii
 const handleComentariuSubmit = async (e) => {
  e.preventDefault();
  if (comentariu.trim() === "") return;
    setLoadingSubmit(true); // <- începe spinnerul


  try {
    
    const auth = getAuth();
    const user = auth.currentUser;
    const colRef = collection(db, "ComentariiBeneficiari", beneficiar.cnp, "comentarii");
await addDoc(colRef, {
  comentariu: comentariu,
  timestamp: Timestamp.now(),
  userEmail: user.email,
    });

    setComentariu("");
    fetchComentarii();

    // Afișează popup-ul
    setShowSuccessPopup(true);
    setTimeout(() => setShowSuccessPopup(false), 3000); // Dispare după 3 secunde

  } catch (error) {
    console.error("Eroare la salvarea comentariului:", error);
    } finally {
    setLoadingSubmit(false); // <- oprește spinnerul
  }

};

  /// Funcția pentru deschiderea modalului cu detaliile utilizatorului
  const handleShowUserDetails = async (userEmail) => {
    const q = query(collection(db, "Utilizatori"), where("email", "==", userEmail));
    const snapshot = await getDocs(q);
    if (!snapshot.empty) {
      const userDetails = snapshot.docs[0].data(); // Detalii utilizator
      setModalUserDetails(userDetails);
    }
  };

  // Închide modalul
  const handleCloseModal = () => {
    setModalUserDetails(null);
  };

  if (!beneficiar) {
    return <p>Se încarcă detaliile...</p>;
  }


  return (
    <div>
      {showSuccessPopup && (
  <div className="popup-succes">
    Comentariul a fost adăugat cu succes!
  </div>
)}
      <div className="detalii-grid">
        <div className="detalii-col">
          <div className="header-orientat">
            {/* Coloană pentru fotografie */}
<div className="column fotografie-col">
  <div className="container-foto-si-buton">
    {localBeneficiar.fotografie ? (
      <div className="container-foto">
        <img
          src={localBeneficiar.fotografie}
          alt="Fotografie beneficiar"
          className={`fotografie-beneficiar ${esteDecedat ? "decedat" : ""}`}
          onClick={() => openImageInNewWindow(localBeneficiar.fotografie)}
        />
        {esteDecedat && (
          <div className="lumanare-overlay" title="Persoană decedată">🕯️</div>
        )}
      </div>
    ) : (
      <div className="fara-fotografie">
        <p><em>Fără fotografie de profil</em></p>
      </div>
    )}

    <input
      id="fileInput"
      type="file"
      accept="image/*"
      onChange={handlePhotoChange}
      style={{ display: "none" }}
      disabled={uploadingPhoto}
    />

    <button
      onClick={openFileDialog}
      disabled={uploadingPhoto}
      className="buton-incarcare-foto"
    >
      {uploadingPhoto
        ? `Se încarcă... (${uploadProgress}%)`
        : localBeneficiar.fotografie
        ? "Schimbă fotografia"
        : "Încarcă fotografie"}
    </button>
  </div>
</div>


            {/* Coloană pentru detalii beneficiar */}
            <div className="column">
              <p>
                <strong>Nume:</strong> {beneficiar.nume}
              </p>
              <p>
                <strong>Prenume:</strong> {beneficiar.prenume}
              </p>
<p>
  <strong>Adăugat în sistem:</strong>{" "}
  {beneficiar.dataAdaugare?.toDate
    ? beneficiar.dataAdaugare.toDate().toLocaleString("ro-RO", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "-"}
</p>


<p>
  <strong>Adăugat de:</strong>{" "}
  {beneficiar?.adaugatDe?.nume && beneficiar?.adaugatDe?.prenume ? (
    <button
      onClick={() => handleShowUserDetails(beneficiar.adaugatDe.email)}
      className="btn btn-link p-0 text-primary"
      style={{ textDecoration: "underline", background: "none", border: "none" }}
    >
      {beneficiar.adaugatDe.nume} {beneficiar.adaugatDe.prenume}
    </button>
  ) : (
    <span>–</span>
  )}
</p>




              <p>
                <strong>CNP:</strong> {beneficiar.cnp}
              </p>
                            <p>
                <strong>Serie/NR CI:</strong> {beneficiar.serienrci}
              </p>
<p>
  <strong>Data nașterii:</strong>{" "}
 {beneficiar.data_nasterii
    ? `${beneficiar.data_nasterii}${!esteDecedat ? ` (${calculeazaVarsta(beneficiar.data_nasterii)} ani)` : ""}`
    : "-"}
</p>


<p>
  <strong>Data decesului:</strong>{" "}
  {beneficiar.datadeces
    ? `${new Date(beneficiar.datadeces).toLocaleDateString("ro-RO", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })} (${calculeazaVarsta(beneficiar.data_nasterii, beneficiar.datadeces)} ani)`
    : "-"}
</p>

              <p>
                <strong>Loc de naștere:</strong> {beneficiar.birthPlace || "-"}
              </p>
              <p>
                <strong>Adresă de domiciliu:</strong> Strada{" "}
                {beneficiar.StradaNumar|| "-"}, {" "}
                {beneficiar.OrasComunaSat || "-"}, {beneficiar.JudetSector || "-"} ,
                Țara {beneficiar.Tara || "-"}
              </p>
              <p>
                <strong>Cetățenie:</strong> {beneficiar.Cetatenie || "-"}
              </p>
              <p>
                <strong>Stare civilă:</strong> {beneficiar.starecivila || "-"}
              </p>
            </div>
            

            <div className="column">
              <p>
                <strong>Profesie:</strong> {beneficiar.Profesie || "-"}
              </p>
              <p>
                <strong>Nivel studii:</strong> {beneficiar.Studii || "-"}
              </p>
              <p>
                <strong>Religie:</strong> {beneficiar.Religie || "-"}
              </p>
              <p>
                <strong>Orientare sexuală:</strong>{" "}
                {beneficiar.OrientareSexuala || "-"}
              </p>
              <p>
                <strong>Sex:</strong> {beneficiar.Sex || "-"}
              </p>
              <p>
                <strong>Identitate de gen:</strong>{" "}
                {beneficiar.IdentitateDeGen || "-"}
              </p>
            </div>

            <div className="column">
              <p>
                <strong>Diagnostic medical:</strong>{" "}
                {beneficiar.DiagnosticMedical}
              </p>
              <p>
  <strong>Status HIV: </strong>
  <span
    style={{
      fontWeight: 'bold',
      color: beneficiar.status_hiv === 'Pozitiv' ? 'red' : 'black'
    }}
  >
    {beneficiar.status_hiv === 'Pozitiv' ? '⚠️ ' : ''}{beneficiar.StatusHIV}
  </span>
</p>
<p>
  <strong>Status TBC: </strong>
  <span
    style={{
      fontWeight: 'bold',
      color: beneficiar.status_tbc === 'Pozitiv' ? 'red' : 'black'
    }}
  >
    {beneficiar.status_tbc === 'Pozitiv' ? '⚠️ ' : ''}{beneficiar.StatusTBC}
  </span>
</p>
              <p>
                <strong>Consum alcool:</strong> {beneficiar.ConsumAlcool}
              </p>
              <p>
                <strong>Consum droguri:</strong> {beneficiar.ConsumDroguri}
              </p>
              <p>
                <strong>Stare autonomie:</strong> {beneficiar.StareAutonomie}
              </p>
              <p>
                <strong>Acceptă asistență:</strong>{" "}
                {beneficiar.AcceptaAsistenta}
              </p>
              <p>
                <strong>Comportament agresiv:</strong>{" "}
                {beneficiar.ComportamentAgresiv}
              </p>
            </div>
          </div>
        </div>
        <div className="container-coloane">
  <div className="coloana-1">
          <h2>&bull; Cea mai recentă interacțiune</h2>
    {ultimaActiune ? (
        <>
<strong>Data și ora:</strong>{" "}
{ultimaActiune?.data_ora?.toDate
  ? ultimaActiune.data_ora.toDate().toLocaleString("ro-RO", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  : "-"}


        <p><strong>Dosar:</strong> {ultimaActiune.dosar}</p>
<p>
  <p><strong>Descriere:</strong> {ultimaActiune.descriere}</p>
<p>
  <strong>Locație:</strong>{" "}
  {ultimaActiune.locatie
    ? typeof ultimaActiune.locatie === "object"
      ? [
          ultimaActiune.locatie.strada,
          ultimaActiune.locatie.numar,
          ultimaActiune.locatie.oras,
          ultimaActiune.locatie.judet,
          ultimaActiune.locatie.taraIdentificare,
        ]
          .filter(Boolean)
          .join(", ")
      : ultimaActiune.locatie
    : "-"}
</p>

    <p><strong>Judet:</strong> {ultimaActiune.judet}</p>

<p></p>
  <strong>Utilizator:</strong>{" "}
  <button
    onClick={() => handleShowUserDetails(ultimaActiune.utilizator_email)}
    className="btn btn-link p-0 text-primary"
    style={{ textDecoration: "underline", background: "none", border: "none" }}
  >
    {ultimaActiune.utilizator_nume} {ultimaActiune.utilizator_prenume}
  </button>
</p>
          <p><strong>Instituția:</strong> {ultimaActiune.utilizator_institutie}</p>
          <p><strong>Funcție:</strong> {ultimaActiune.utilizator_functie}</p>
          <p><strong>Fișier:</strong> {ultimaActiune.fisier_url ? (
            <a href={ultimaActiune.fisier_url} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
              Vezi fișier
            </a>
          ) : (
            <span>–</span>
          )}</p>
        </>
      ) : (
        <p>Nu există date pentru ultima acțiune.</p>
      )}
    </div>

  
 {/* Formular pentru comentarii */}
        {/* Formular pentru comentarii */}
<div className="coloana-3">
  <h2>&bull; Adaugă un comentariu</h2>
<form onSubmit={handleComentariuSubmit} className="comentarii-form">
  <textarea
  value={comentariu}
  onChange={(e) => {
    setComentariu(e.target.value);

    // Resetăm înălțimea la minim pentru a calcula corect scrollHeight
    e.target.style.height = "28px";  
    e.target.style.height = `${e.target.scrollHeight}px`;
  }}
  placeholder="Introduceți comentariul aici..."
  className="comentarii-input"
  disabled={loadingSubmit}
  rows={1}
/>

  <button
    type="submit"
    className="submit-comentariu"
    disabled={loadingSubmit || !comentariu.trim()}
  >
    {loadingSubmit ? (
      <div className="spinner"></div>
    ) : (
      <span className="send-icon">➤</span>
    )}
  </button>
</form>



</div>
   
        </div>
        <div className="container-comentarii">
  <h3 className="comentarii-titlu">Comentarii</h3>
  {loadingComentarii ? (
    <p>Se încarcă comentariile...</p>
  ) : comentarii.length > 0 ? (
    comentarii.map((comentariu, index) => {
      const auth = getAuth();
      const user = auth.currentUser;
      const isEditable = user?.email === comentariu.userEmail &&
        ((new Date() - (comentariu.timestamp?.toDate ? comentariu.timestamp.toDate() : new Date(comentariu.timestamp))) / (1000*60*60) <= 24);

      return (
        <div key={index} className="comentariu-card">
          <div className="comentariu-header">
            <div className="avatar">{comentariu.userFullName?.charAt(0) || "U"}</div>
            <div>
              <span className="comentariu-user" onClick={() => handleShowUserDetails(comentariu.userEmail)}>
                {comentariu.userFullName || comentariu.userEmail}
              </span>
              <span className="comentariu-time">
                {comentariu.timestamp?.toDate
                  ? comentariu.timestamp.toDate().toLocaleString("ro-RO", {day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit"})
                  : "-"}
              </span>
              {isEditable && (
  <div style={{ display: "inline-block", position: "relative", marginLeft: "8px" }}>
    {/* Butonul cu 3 puncte */}
<button
  onClick={() =>
    setShowDropdownId((prev) => (prev === comentariu.id ? null : comentariu.id))
  }
  style={{
    background: "rgba(0,0,0,0.05)", // semi-transparent
    border: "none",
    borderRadius: "50%",
    cursor: "pointer",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    transition: "background 0.2s"
  }}
  onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.15)")}
  onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.05)")}
  title="Opțiuni comentariu"
>
  ✎
</button>


    {/* Dropdown */}
    {showDropdownId === comentariu.id && (
      <div
        style={{
          position: "absolute",
          top: "100%",
          right: 0,
          background: "white",
          border: "1px solid #ccc",
          borderRadius: "4px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          zIndex: 100,
          minWidth: "100px"
        }}
      >
        <button
          onClick={() => {
            startEditComentariu(comentariu);
            setShowDropdownId(null);
          }}
          style={{
            display: "block",
            width: "100%",
            padding: "4px 8px",
            background: "transparent",
            border: "none",
            textAlign: "left",
            cursor: "pointer",
            color: "black",
          }}
        >
          Editare
        </button>
        <button
          onClick={() => handleDeleteComentariu(comentariu.id)}
          style={{
            display: "block",
            width: "100%",
            padding: "4px 8px",
            background: "transparent",
            border: "none",
            textAlign: "left",
            cursor: "pointer",
            color: "red"
          }}
        >
          Ștergere
        </button>
      </div>
    )}
  </div>
)}
            </div>
          </div>

<div className="comentariu-text">
  {editingComentariuId === comentariu.id ? (
    <>
      <textarea
        value={editingComentariuText}
        onChange={(e) => setEditingComentariuText(e.target.value)}
        rows={2}
        style={{ width: "100%" }}
      />
      <button onClick={saveEditComentariu}>Salvează</button>
      <button onClick={() => setEditingComentariuId(null)}>Anulează</button>
    </>
  ) : (
    <>
      <span>{comentariu.comentariu}</span>
      {comentariu.editedAt && (
        <span style={{ fontStyle: "italic", marginLeft: "6px" }}>(editat)</span>
      )}



      {/* Afișare comentariu vechi la click */}
      {comentariu.previousComentariu && (
        <div style={{ marginTop: "4px" }}>
          <button
            onClick={() => toggleOldComment(comentariu.id)}
            style={{
              fontSize: "0.85em",
              color: "#007bff",
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 0
            }}
          >
            {showOldCommentIds.includes(comentariu.id)
              ? "Ascunde comentariul inițial"
              : "Afișează comentariul inițial"}
          </button>
          {showOldCommentIds.includes(comentariu.id) && (
            <div style={{ fontSize: "0.85em", color: "#555", marginTop: "2px" }}>
              {comentariu.previousComentariu}
            </div>
          )}
        </div>
      )}
    </>
  )}
</div>

        </div>
      );
    })
  ) : (
    <p>Nu există comentarii.</p>
  )}
</div>


      </div>
      {/* Afișează modalul dacă există detalii ale utilizatorului */}
      {modalUserDetails && (
        <UserDetailsModal userDetails={modalUserDetails} onClose={handleCloseModal} />
      )}
    </div>
  );
};

export default PrivireGenerala;
